import LayoutActividad from "../../../components/LayoutActividad";
import Variedad1 from "../../../images/modulo14/variedad1.png";
import Variedad2 from "../../../images/modulo14/variedad2.png";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[1];
  const infoAct = modulo14.content[1].activities[11];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[2].name}: ${modulo14.content[2].activities[0].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[2].path}/${modulo14.content[2].activities[0].path}`,
    titlePrev: `${modulo14.content[1].name}: ${modulo14.content[1].activities[10].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[1].path}/${modulo14.content[1].activities[10].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>

      <div className="bg-light p-4 mt-5 rounded">
        <div className="row align-items-center">
          <div className="col-md-4">
            <img
              src={Variedad1}
              className="bg-white img-fluid rounded"
              alt="Variedad Castellano"
            />
          </div>
          <div className="col-md-8 p-md-3 p-0">
            <h4 className="mb-4">
              <strong>Del castellano peruano sus variedades</strong>
            </h4>
            <p className="mt-1">
              Una de las variedades de castellano que más se habla en el Perú es
              el <strong>castellano andino</strong>. El castellano andino tiene
              influencia del quechua y del aimara. En un principio, se hablaba
              solo en la sierra del Perú, pero hoy se habla por todo el país
              debido a las migraciones.
            </p>
          </div>

          <div className="col-md-8 p-md-3 p-0">
            <p>
              También se habla en el Perú el castellano de la selva o{" "}
              <strong>castellano amazónico</strong>. Este tiene influencia de
              las diversas lenguas originarias que se hablan en la Amazonía del
              Perú.
            </p>
            <p>
              A pesar de que nuestros castellanos son distintos, esta lengua nos
              permite comunicarnos, dialogar y debatir. A veces nos pondremos de
              acuerdo y a veces no.
            </p>
          </div>
          <div className="col-md-4">
            <img
              src={Variedad2}
              className="bg-white img-fluid rounded"
              alt="Variedad Castellano"
            />
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean el texto titulado Del castellano sus variedades.
          </li>
          <li>
            Según el texto leído, pregunte lo siguiente:{" "}
            <i>
              ¿qué es el castellano andino? ¿Qué ejemplo vemos en las
              ilustraciones? (Syndi usa castellano amazónico por el orden en que
              coloca las palabras en la oración, el doble posesivo y por el uso
              del término “huambrilla” (niña); Olga usa castellano andino por el
              doble posesivo (SU guagua DE mi amiga) y por el uso del término
              “guagua” (bebe, niño pequeño).
            </i>
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
